import { getFragmentData } from "@/__generated__";
import type {
  InvoiceByIdQuery,
  InvoiceByIdQueryVariables,
} from "@/__generated__/graphql";
import {
  InvoiceByIdDocument,
  InvoiceDetailFragmentFragmentDoc,
  InvoiceStatusEnum,
  InvoicePaymentStatusEnum,
} from "@/__generated__/graphql";
import type { InvoiceDetailData } from "@/containers/profile/invoices/invoice-detail/lib";
import { getInvoiceDetailData } from "@/containers/profile/invoices/invoice-detail/lib";

import { createRequestFactory } from "@/lib/request-factory";
import { useInvoiceState } from ".";
import { getDecimalFixed } from "@/lib/helpers/number";

const initialInvoiceData: InvoiceDetailData = {
  id: "",
  amount: 0,
  balance: 0,
  paidAmount: 0,
  baseAmount: 0,
  paymentStatus: InvoicePaymentStatusEnum.Unpaid,
  fromDate: new Date(),
  toDate: new Date(),
  issueDate: new Date(),
  dueDate: new Date(),
  status: InvoiceStatusEnum.New,
  pdfUrl: null,
  totalAmount: 0,
  pdfReceiptUrl: null,
  appliedVoucher: null,
  lineItems: [],
  qrCodeUrl: "",
  discountAmount: 0, // fixed price discount
  lineItemsTotal: 0,
};

export const useInvoiceDetailStore = createRequestFactory<
  InvoiceByIdQuery,
  InvoiceDetailData,
  InvoiceByIdQueryVariables
>(
  {
    method: "query",
    graphqlDocument: InvoiceByIdDocument,
    fetchPolicy: "network-only",
    transformFunction(data) {
      const invoice = getFragmentData(
        InvoiceDetailFragmentFragmentDoc,
        data.invoiceById,
      );
      return getInvoiceDetailData(invoice);
    },
    onFetchSuccess(data) {
      // TODO: refactor this unnecessary state updates, we can get the values from the useInvoiceDetailStore.data
      const balance = data.totalAmount - data.paidAmount;
      useInvoiceState.getState().setInvoiceId(data.id);
      useInvoiceState.getState().setBaseAmount(data.lineItemsTotal);
      useInvoiceState.getState().setAmount(data.amount);
      useInvoiceState.getState().setPaidAmount(data.paidAmount);
      useInvoiceState.getState().setBalance(getDecimalFixed(balance, 2));
      useInvoiceState.getState().setCurrentBalance(getDecimalFixed(balance, 2));
      useInvoiceState.getState().setAppliedVoucher(data.discountAmount);
    },
  },
  initialInvoiceData,
);
